import React from "react";
import Modal from "react-responsive-modal";
import Constant from "../../Constant";
import $ from "jquery";

class Query extends React.Component {
  constructor() {
    super();
    this.state = {
      list_arry: [],
      open: false,
      isToggleOpen: false,
      value: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleIdImage = this.handleIdImage.bind(this);
  }
  handleIdImage(file) {
    document.getElementById("id_image_section_lable").innerHTML = "";
    let element = $("#profile_image").get(0);
    $("#id_image_section").empty();
    this.setState({ accepted: element });
    var proof_img = [];
    let obj = {};
    console.log(element.files);
    for (var i = 0; i < element.files.length; i++) {
      var file1 = element.files[i];
      var img = document.createElement("img");
      img.className = "proof_img img-responsive img-circle";
      img.style.display = "inline-block";
      var filePath = URL.createObjectURL(file1);
      img.src = filePath;
      $("#id_image_section").append(img);
      console.log(URL.createObjectURL(file1));

      console.log(file1.type);
    }
    this.media_load();
  }
  media_load = () => {
    var that = this;
    that.setState({ isLoading: true });
    var form = $("#profile")[0];
    var data = new FormData(form);
    data.append("domain_short_code", localStorage.getItem("sk_code"));
    fetch(Constant.getAPI() + `/uploadimage`, {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
          that.setState({ media_arr: json.data });
          var list_arry = [];
          for (var i = 0; i < json.data.length; i++) {
            var list = {};
            list.media_id = json.data[i].media_id;
            var a = json.data[i].url.split(".").pop();
            if (a == "jpeg" || a == "jpg" || a == "png" || a == "gif") {
              list.media_type_id = 1;
            } else if (a == "mp4" || a == "avi" || a == "wmv") {
              list.media_type_id = 2;
            } else if (a == "mp3") {
              list.media_type_id = 4;
            }
            list_arry.push(list);
          }
          that.setState({ list_arry: list_arry });
        } else {
          that.setState({ isLoading: false });
          console.log(json.error);
        }
      });
  };
  handleChange(event) {
    this.setState({ value: event.target.value });
  }
  handleClick = event => {
    // This prevents ghost click.
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  };
  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };
  addpost = () => {
    var that = this;
    var data = new FormData();
    data.append("user_id", localStorage.getItem("sk_uid"));
    data.append("query", that.state.value);
    data.append("language_id", Constant.language_id());
    data.append("coursemaster_id", this.props.coursemaster_id);
    data.append("game_id", this.props.game_id);
    data.append("domain_id", localStorage.getItem("sk_dom_sh_code"));
    if (this.state.list_arry != []) {
      data.append("media_arr", JSON.stringify(that.state.list_arry));
    }
    fetch(Constant.getAPI() + "/addpost", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
        } else {
          that.setState({ isLoading: false });
          console.log(json.error);
        }
      });

    this.handleIdImage = this.handleIdImage.bind(this);
  };
  handleSubmit = () => {
    if (this.state.value == "") {
      alert("please enter your query ");
    } else {
      this.addpost();
      setTimeout(() => {
        window.location.href = "#/notifications"
      }, 1000);
    }
  };
  Close = () => {
    window.location.href = "#/course_desc/" + this.props.course_id;
  };
  render() {
    const { open } = this.props;
    return (
      <Modal open={open} onClose={this.Close} little>
        <div className="card card-style-3 border-0 text-center ">
          <div className="card-body">
            <h3 className="font-weight-bold mb-3 text-primary">Post Query</h3>
            <hr />
            <div className="row">
              <textarea
                rows="10"
                cols="25"
                placeholder="Enter your query"
                className="col "
                value={this.state.value}
                onChange={this.handleChange}
              />
            </div>
            <div className="row">
              <div className="col p-2">
                <button
                  className="btn btn-primary "
                  onClick={this.handleSubmit}
                >
                  Send
                </button>
              </div>
              <div className="col-md-1 col p-2">
                <form
                  method="post"
                  id="profile"
                  name="userRegistrationForm2"
                  encType="multipart/form-data"
                >
                  <div id="id_image_section_lable" />
                  <input
                    accept="image/*"
                    onChange={this.handleIdImage}
                    multiple
                    id="profile_image"
                    type="file"
                    autoComplete="off"
                    name="media[]"
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "0px",
                      bottom: "0px",
                      left: "0px",
                      opacity: " 1e-05",
                      width: "100%"
                    }}
                  />
                  <label htmlFor="profile_image">
                    {" "}
                    <i className="fas fa-paperclip text-4 m-2" />
                  </label>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default Query;
